import './Section1Component.css'

import Lanzamiento from './images/Lanzamiento-img.png'

export const Section1Component = () => {
    return (
        <div id='section1' className="blue_bg pb-3 pb-lg-5">
            <div className="container2-Section1">
                <div className="row m-0 p-0">

                    <div className="col-12 col-lg-4 p-0 text-center text-lg-start white_cl">
                        
                        <div className='textoSeccion1'>
                            <span className='rubik_regular ' style={{fontWeight:'lighter'}} >EN <span className='rubik_bold'>GIROS Y FINANZAS</span> HEMOS DADO EL <strong className='rubik_bold'>GIRO MÁS GRANDE DE NUESTRA HISTORIA</strong> </span>
                        </div>
                    </div>

                    <div className="col-12 col-lg-8 p-0 text-center text-lg-start">
                        <div className="container-reloj">
                            <img src={Lanzamiento} alt="Reloj de Arena" className='reloj_arena'/>
                        </div>
                        
                        
                    </div>
                    <h4 className='Texto2Introduccion'>HOY SOMOS <br/> <strong className='rubik_bold'>BANCO UNIÓN</strong> </h4>
                </div>
            </div>
        </div>
    )
}